/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Type_Text4Inputs */

const en__field__enum_type_text4 = /** @type {(inputs: _Field__Enum_Type_Text4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text`)
};

/** @type {(inputs: _Field__Enum_Type_Text4Inputs) => LocalizedString} */
const de__field__enum_type_text4 = en__field__enum_type_text4;

/**
* | output |
* | --- |
* | "Text" |
*
* @param {_Field__Enum_Type_Text4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_type_text4 = /** @type {((inputs?: _Field__Enum_Type_Text4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Type_Text4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_type_text4(inputs)
	return de__field__enum_type_text4(inputs)
});
export { _field__enum_type_text4 as "_field__enum_type_TEXT" }